import TurntableImageBox from "designSystem/components/box/TurntableImageBox";
import { CsiImage, Text } from "designSystem/index";
import React from "react";
import CssColumnGrid from "../../CssColumnGrid";
import image1 from "./turntable/1.png";
import image2 from "./turntable/2.png";
import image3 from "./turntable/3.png";
import image4 from "./turntable/4.png";
import image5 from "./turntable/5.png";
import image6 from "./turntable/6.png";
import image7 from "./turntable/7.png";
import image8 from "./turntable/8.png";

export default () => {
	const arr = [image1, image2, image3, image4, image5, image6, image7, image8];
	return (
		<CssColumnGrid columns={3}>
			<Text semiBold text="example (turntable)" />
			<Text semiBold text="example (disabled turntable)" />
			<Text semiBold text="example (not turntable)" />
			<TurntableImageBox imageList={arr} />
			<TurntableImageBox disableTurntable imageList={arr} />
			<TurntableImageBox imageList={[image1]} />
		</CssColumnGrid>
	);
};
